import { z } from 'zod';

// Single definition of the client env contract, shared by two evaluators:
//   - src/env.ts        -> browser, at module-eval time (@t3-oss/env-core)
//   - vite.config.ts    -> Node, before bundling (build-time guard)
// Do not inline a second copy of these keys anywhere.
export const clientEnvSchema = {
	// Optional (NOT .min(1)): when unset, the app renders mock data.
	// A legally-absent base URL is the mock-mode signal — see .env.example.
	VITE_API_URL: z.string().optional(),
	VITE_ENV: z.enum(['Dev', 'Test', 'Stage', 'Prod']),
};

// Mirrors createEnv's `emptyStringAsUndefined: true` so the build-time guard and
// the runtime validator agree that VITE_ENV='' is missing, not merely invalid.
export function parseClientEnv(runtimeEnv: Record<string, string | undefined>) {
	const nonEmpty = Object.fromEntries(
		Object.entries(runtimeEnv).filter(([, value]) => value !== ''),
	);
	return z.object(clientEnvSchema).safeParse(nonEmpty);
}
